import React, { useState } from 'react';
import axios from 'axios';
import Botpoison from '@botpoison/browser';
import MarketingConsent from '../components/MarketingConsent';
import './Contact.css';
import instagramIcon from '../assets/insta.jpeg';

// Create Botpoison instance with the provided public key
const botpoison = new Botpoison({
  publicKey: "pk_dfa2d461-5956-459f-b74f-effe29b93222"
});

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    message: '',
    marketingConsent: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Process Botpoison challenge
      const { solution } = await botpoison.challenge();
      
      // Submit to Formspark
      await axios.post('https://submit-form.com/1gaMAFaxt', {
        fullName: formData.fullName,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        message: formData.message,
        marketingConsent: formData.marketingConsent ? 'Yes' : 'No',
        _botpoison: solution,
      });

      setSubmitStatus('success');
      setFormData({
        fullName: '',
        email: '',
        phoneNumber: '',
        message: '',
        marketingConsent: false
      });
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-info">
        <p className="contact-phone">Call us: <a href="tel:+16505822333">(650) 582 - 2333</a></p>
        <p className="contact-address">644 Laurel Street suite C, San Carlos, CA 94070</p>
        <a 
          href="https://www.instagram.com/highlands_sports_bar/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="instagram-button"
        >
          <img src={instagramIcon} alt="Instagram" className="instagram-icon" />
          Follow us on Instagram
        </a>
      </div>
      
      <h1 className="contact-title">Connect With Us</h1>
      <p className="contact-subtitle">Please complete the form below and we'll get back to you as soon as we can.</p>
      
      {submitStatus === 'success' && (
        <div className="success-message">
          Thank you for your message! We'll get back to you as soon as possible.
        </div>
      )}
      
      {submitStatus === 'error' && (
        <div className="error-message">
          Sorry, there was an error submitting your message. Please try again or contact us directly.
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label htmlFor="fullName">Full Name<span className="required">*</span></label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Full Name"
            required
            disabled={isSubmitting}
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email<span className="required">*</span></label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            required
            disabled={isSubmitting}
          />
        </div>

        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number<span className="required">*</span></label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            placeholder="(555) 555-5555"
            required
            disabled={isSubmitting}
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="4"
            placeholder="Your message here..."
            disabled={isSubmitting}
          />
        </div>

        <MarketingConsent
          checked={formData.marketingConsent}
          onChange={handleChange}
          disabled={isSubmitting}
        />

        <button type="submit" className="submit-button" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </form>
    </div>
  );
};

export default Contact; 